module.exports = __webpack_public_path__ + "images/emoji/tshirt.399f2f4bab4752a4b0b6.png";